const builderViewOrder = ['customer', 'survey', 'equipment', 'accessories', 'installation', 'summary'].map(
	r => `proposal.${r}`
);
const targetRoutes = ['proposal.**', 'office.**', 'user.**', 'navigator', 'preview.**'];
const stateBeforeChangeStart = ($transitions, $window) => {
	let pendingDirection = null;
	// resolver for the in-flight view transition. startViewTransition freezes the DOM until the
	// callback's promise settles, and the browser aborts with a timeout if it waits too long, so
	// this must ALWAYS be released (success, error, or a safety timeout) and never left dangling.
	let resolveSwap = null;
	let safetyTimer = null;

	function releaseSwap() {
		if (safetyTimer) {
			$window.clearTimeout(safetyTimer);
			safetyTimer = null;
		}
		if (resolveSwap) {
			resolveSwap();
			resolveSwap = null;
		}
	}

	// capture direction and start the view transition before the DOM changes
	$transitions.onBefore({to: targetRoutes}, trans => {
		if (!document.startViewTransition) return;
		// a prior transition's view transition is still pending (redirect/supersede): release it
		releaseSwap();

		const fromIndex = builderViewOrder.indexOf(trans.from().name);
		const toIndex = builderViewOrder.indexOf(trans.to().name);
		pendingDirection = toIndex > fromIndex ? 'to-left' : 'to-right';

		document.body.classList.remove('to-left', 'to-right');
		document.body.classList.add(pendingDirection);

		// startViewTransition snapshots the current (old) DOM now, then runs our callback; the
		// crossfade plays once the returned promise resolves (in onSuccess, once the view swapped).
		const viewTransition = document.startViewTransition(
			() =>
				new Promise(resolve => {
					resolveSwap = resolve;
					// safety net: never let the browser hit its own DOM-update timeout if ui-router
					// is slow or the transition is superseded without firing success/error
					safetyTimer = $window.setTimeout(releaseSwap, 1000);
				})
		);
		// a superseded transition rejects (updateCallbackDone/ready/finished); swallow it so a
		// skipped/aborted view transition does not surface as an unhandled runtime error
		viewTransition.updateCallbackDone.catch(() => {});
		viewTransition.ready.catch(() => {});
		viewTransition.finished.catch(() => {});
	});

	// the view has swapped: let the view transition finish the crossfade
	$transitions.onSuccess({to: targetRoutes}, () => {
		pendingDirection = null;
		releaseSwap();
	});

	// cancelled/errored transition: release the pending view transition so the DOM is not frozen
	$transitions.onError({to: targetRoutes}, () => {
		pendingDirection = null;
		releaseSwap();
	});
};
stateBeforeChangeStart.$inject = ['$transitions', '$window'];
export default stateBeforeChangeStart;
